import {useEffect, useState} from 'react';

export default function useStorageState([storage, key], defaultValue = undefined) {
  const hasStorageValue = key in storage;
  const storageValue = hasStorageValue ? JSON.parse(storage[key]) : defaultValue;

  const [state, setState] = useState(storageValue);
  useEffect(() => {
    setState(storageValue);
  }, [storageValue !== state]);

  useEffect(() => {
    // state -> persist
    storage[key] = JSON.stringify(state);
  }, [state]);

  return [state, setState];
}
